module.exports = __webpack_public_path__ + "img/scsp.1c6ea7e4.png";